import usePermissionStatusByKey from '../../../../hooks/usePermissionStatusByKey';


function useGiveawayDetailsPagePermissions() {
    const isGiveaway = usePermissionStatusByKey('POST:/admin/giveaways/:id');

    const isFinishGiveaway = usePermissionStatusByKey('POST:/admin/giveaways/finish/:id');
    const isGenerateGiveawayWinners = usePermissionStatusByKey('POST:/admin/winners/generate/:giveawayId/all');
    const isGiveawayWinners = usePermissionStatusByKey('GET:/admin/winners/:giveawayId');
    const isGiveawayEntries = usePermissionStatusByKey('GET:/admin/giveaways/:id/entries');

    const isRevealWinner = usePermissionStatusByKey('PATCH:/admin/winners/:id/visible');
    const isGiveawayGenerateWinners = usePermissionStatusByKey('POST:/admin/winners/generate/:giveawayId/all');
    const isGiveawayGenerateWinner = usePermissionStatusByKey('POST:/admin/winners/generate/:giveawayId');

    const isWheel = isRevealWinner && isGiveawayGenerateWinners && isGiveawayGenerateWinner;
    const isActivityLogs = usePermissionStatusByKey('GET:/admin/activity-logs');

    const isGiveawayDetailsPage = isGiveaway || isFinishGiveaway || isGenerateGiveawayWinners || isGiveawayWinners || isGiveawayEntries || isWheel || isActivityLogs;
    return {
        isGiveaway,
        isGiveawayDetailsPage,
        isActivityLogs,
        isFinishGiveaway,
        isGenerateGiveawayWinners,
        isGiveawayWinners,
        isGiveawayEntries,
        isWheel
    };
}

export default useGiveawayDetailsPagePermissions;
